{
  "viewMore": "Gweld mwy",
  "or": "neu",

  "appTitle": "Adrodd + Chymorth",
  "supportTitle": "Cymorth",
  "campaignsTitle": "Ymgyrchoedd",
  "reportTitle": "Adrodd",
  "cookieControlLink": "Rheoli Cwcis",
  "insightsTitle": "Adroddiadau mewnwelediad",

  "cultureShift": "Culture Shift",
  "homeTitle": "Cymorth",
  "menuLabel": "Dewislen",
  "closeMenuLabel": "Cau’r ddewislen",
  "skipToContent": "Neidio i’r cynnwys",

  "licensedBy": "Trwyddedwyd gan",
  "connectWithUs": "Cysylltu â Ni",
  "emailUs": "Anfon e-bost atom",
  "getInTouch": "Cysylltu",
  "viewOnMap": "Gweld ar fap",
  "address": "Cyfeiriad",

  "cookieControlTitle": "Gosodiadau cwcis",
  "cookieControlBody": "Hoffem osod cwcis dadansoddol i'n helpu i wella ein gwefan drwy gasglu ac adrodd gwybodaeth am sut rydych chi'n ei defnyddio. Mae'r cwcis yn casglu gwybodaeth mewn ffordd nad yw'n adnabod unrhyw un yn uniongyrchol.",
  "cookieAccept": "Derbyn",
  "cookieDecline": "Gwrthod",
  "cookieAllow": "Caniatáu cwcis dadansoddol",

  "reportCta_interval": "(0)[Ni allwch adrodd am faterion drwy’r wefan hon ar hyn o bryd];(1)[Gallwch roi gwybod i ni beth ddigwyddodd trwy’r wefan hon];(2)[Mae dwy ffordd y gallwch ddweud wrthym beth ddigwyddodd];(3)[Mae tair ffordd y gallwch ddweud wrthym beth ddigwyddodd];(4-inf)[Mae nifer o ffyrdd y gallwch ddweud wrthym beth ddigwyddodd];",

  "backLabel": "Nôl",
  "continueLabel": "Parhau",
  "reportNowLabel": "Adrodd nawr",
  "skipToEndLabel": "Neidiwch y cwestiynau hyn",
  "skipToEndFallbackIntro": "Mae’r cwestiynau canlynol yn rhai dewisol. Bydd ateb y cwestiynau hyn yn helpu ein tîm i gadw llygad ar dueddiadau a phroblemau ar draws y sefydliad.",
  "sendReportLabel": "Anfon adroddiad",
  "thankYouTitle": "Diolch",
  "reviewAnswers": "Adolygwch eich atebion cyn cyflwyno eich adroddiad",
  "questionNotAnswered": "Ni wnaethoch ateb y cwestiwn hwn",
  "imagesAttached_one": "{{count}} delwedd wedi’i hatodi",
  "imagesAttached_other": "{{count}} delwedd wedi’u hatodi",
  "change": "Newid",
  "otherPleaseSpecify": "Os arall, nodwch",
  "additionalSupport": "Cefnogaeth ychwanegol",

  "messageCodeText": "Gallwch ddychwelyd a siarad â ni unrhyw bryd trwy gadw’r cod mynediad unigryw isod.",
  "messageCodeAlert": "Gwnewch yn siŵr eich bod yn cadw cofnod o’r cod mewn man diogel gan na fydd modd ei adfer unwaith i chi adael y dudalen hon",
  "messageCodeCopied": "Wedi’i gopïo i’r clipfwrdd",
  "messageCodeLogin": "Mewngofnodi",

  "messagingMessagesTab": "Negeseuon",
  "messagingSettingsTab": "Gosodiadau",
  "alreadyReported": "Wedi adrodd yn barod?",
  "messagingCodeTitle": "Negeseuon",
  "messagingCodeLogInBodyHome": "Os ydych wedi cyflwyno adroddiad ac wedi cael cod i siarad â gweithiwr achos gallwch fewngofnodi isod",
  "messagingLogIn": "Mewngofnodi i Negeseuon",
  "messagingCodeLogInBody": "Rhowch eich cod unigryw isod i fewngofnodi a siarad â ni.",
  "messagingCodeSubmit": "Cyflwyno",
  "messagingCodeInvalid": "Nid yw’r cod hwn yn ddilys",
  "messagingCode": "Cod mewngofnodi",
  "messagingCodeHelp": "Beth os nad oes gennyf god mynediad? Os ydych wedi cyflwyno adroddiad a heb gadw’r cod bydd angen i chi gyflwyno adroddiad newydd",
  "messagingCodeWarning": "Os na wnaethoch nodyn o’ch cod pwyswch y botwm yn ôl yn eich porwr",
  "messagingCodeDisabled": "Mae eich cyfrif wedi’i analluogi",
  "messagingCodeDisabledByCaseworker": "Mae’r gweithiwr achos wedi analluogi negeseua",
  "messagingDisableAccountTitle": "Analluogi cyfrif",
  "messagingDisableAccountBody": "Gallwch ddefnyddio’r nodwedd hon os ydych yn poeni bod eich cyfrif dan fygythiad. Drwy analluogi eich cyfrif byddwch yn colli mynediad am byth i’r ardal hon y mewngofnodwyd iddi, ni ellir dadwneud y weithred hon.",
  "messagingDisableAccountButton": "Analluogi cyfrif",
  "messagingDisableAccountConfirm": "Cadarnhau analluogi cyfrif",
  "messagingDisableAccountModal": "A ydych yn siŵr eich bod am analluogi eich cyfrif a cholli mynediad am byth i’ch negeseuon? Ni ellir dadwneud y weithred hon.",

  "messagingLogoutAccountButton": "Allgofnodi",

  "downloadReport": "Lawrlwytho eich adroddiad",
  "cancel": "Canslo",

  "reporterMessagingErrorTitle": "Gwall wrth lwytho negeseuon",
  "reporterMessagingErrorBody": "Mae’n ddrwg gennym, bu gwall wrth lwytho negeseuon, ail-lwythwch y dudalen neu dychwelwch yn ddiweddarach.",

  "reporterMessagingEmptyTitle": "Dim negeseuon",
  "reporterMessagingEmptyBody": "Nid oes negeseuon ar hyn o bryd, teipiwch neges yn y blwch uchod.",

  "sendMessageError": "Digwyddodd gwall wrth anfon eich neges",
  "unexpectedErrorOnLogin": "Digwyddodd gwall wrth eich mewngofnodi",

  "reportMessagingSendMessage": "Anfon neges",
  "reportMessagingTextAreaLabel": "Neges",
  "today": "Heddiw",
  "you": "Chi",
  "caseWorker": "Gweithiwr achos",
  "redacted": "Golygwyd",
  "added": "Ychwanegwyd",
  "notAnswered": "Heb ei ateb",
  "form": "Ffurflen",
  "yourReport": "Eich adroddiad",
  "removed": "Gwaredwyd",
  "reportAmended": "Mae peth o’r cynnwys yn eich adroddiad wedi cael ei newid neu ei olygu yn unol â’n Hysbysiad Preifatrwydd",
  "newTab": "Agor mewn tab newydd",
  "noAnswerPermission": "Nid oes gennych ganiatâd i weld yr ateb hwn",
  "invalidImage": "Nid yw'r ddelwedd hon yn ddilys neu efallai ei bod wedi'i llygru yn ystod y broses uwchlwytho adroddiad",

  "filesTooLargeError": "<strong>Nid oes unrhyw un o’ch ffeiliau wedi’u huwchlwytho</strong> oherwydd bod cyfanswm y maint yn fwy na’r terfyn o <strong>{{limit}}MB</strong>",
  "imageFormatError": "<strong>Nid oes unrhyw un o’ch ffeiliau wedi’u huwchlwytho</strong> oherwydd ni chefnogir un neu fwy o fathau o ffeiliau. Uwchlwythwch fformat delwedd dilys megis <strong>jpg, png, neu gif</strong>",
  "thankYouImageError_one": "Mae eich adroddiad wedi’i gyflwyno, ond nid oedd un o’r ffeiliau a uwchlwythwyd gennych yn y fformat derbyniol felly nid yw wedi’i huwchlwytho",
  "thankYouImageError_other": "Mae eich adroddiad wedi’i gyflwyno, ond nid oedd {{count}} o’r ffeiliau a uwchlwythwyd gennych yn y fformat derbyniol felly nid ydynt wedi’u huwchlwytho",
  "someFilesTooLargeError_one": "<strong>Ni chafodd un o’ch ffeiliau ei huwchlwytho</strong> oherwydd ei bod yn fwy na’r terfyn o <strong>{{limit}}MB</strong>",
  "someFilesTooLargeError_other": "<strong>Ni chafodd {{count}} o’ch ffeiliau eu huwchlwytho</strong> oherwydd eu bod yn fwy na’r terfyn o <strong>{{limit}}MB</strong>",
  "someFilesNotImagesError_one": "<strong>Ni chafodd un o’ch ffeiliau ei huwchlwytho</strong> oherwydd ni chefnogir y math o ffeil. Uwchlwythwch fformat delwedd dilys megis <strong>jpg, png, or gif</strong>",
  "someFilesNotImagesError_other": "<strong>Ni chafodd {{count}} o’ch ffeiliau eu huwchlwytho</strong> oherwydd nid yw’r mathau o ffeiliau yn cael eu cefnogi. Uwchlwythwch fformat delwedd dilys megis <strong>jpg, png, neu gif</strong>",
  "someFilesRejectedError": "<strong>Ni chafodd {{count}} o’ch ffeiliau eu huwchlwytho</strong> oherwydd eu bod yn rhy fawr neu eu bod yn y fformat anghywir. Uwchlwythwch fformat delwedd dilys megis <strong>jpg, png, neu gif</strong>",
  "pageIncompleteError": "Atebwch y cwestiynau cyn parhau",
  "selectedFileCount": "({{count}} delwedd a ddewiswyd yn flaenorol)",
  "sendingReport": "Wrthi’n uwchlwytho adroddiad...",
  "doNotCloseTab": "Peidiwch â chau’r tab porwr hwn.",
  "required": "Mae’r cwestiwn hwn yn ofynnol.",
  "csrfFailure": "Aeth rhywbeth o’i le. Gwiriwch eich atebion a cheisiwch eto.",
  "noCaptchaTitle": "Gwall captcha",
  "noCaptchaBody": "Ni dderbyniwyd eich cyflwyniad oherwydd na wnaethoch chi gwblhau'r captcha",
  "duplicateSession": "Rydych chi wedi cyflwyno'r ffurflen hon fwy nag unwaith. Dim ond y cyflwyniad cyntaf sydd wedi'i dderbyn",
  "NoSessionTitle": "Dim sesiwn",
  "NoSessionBody": "Ni dderbyniwyd eich cyflwyniad oherwydd nad oes gennych sesiwn ddilys",
  "captchaFailed": "Nid oeddem yn gallu gwirio eich bod yn ddynol",
  "captchaFailedLink": "Ceisiwch eto",
  "captchaLoading": "Arhoswch tra bod y Captcha yn llwytho...",
  "captchaPassed": "Nid wyf yn robot",
  "noAnswersTitle": "Aeth rhywbeth o'i le",
  "noAnswersBody": "Ni dderbyniwyd eich cyflwyniad oherwydd na wnaethoch ateb unrhyw gwestiynau. Rhowch gynnig arall arni.",

  "maxCharacters": "Uchafswm o {{count}} nod",
  "charactersLeft": "{{count}} nod yn weddill",
  "charactersOver": "{{count}} nod drosodd",
  "maxCharactersShorthand": "{{used}}/{{limit}} nod",
  "maxCharactersError": "Cyfyngwch eich ateb i {{count}} nod",
  "errorSummaryTitle_one": "Mae problem gyda’r cwestiwn canlynol",
  "errorSummaryTitle_other": "Mae problem gyda’r cwestiynau canlynol",
  "errorLabelTitle": "Gwall:",
  "textQuestionInvalid": "Rhowch ateb",
  "emailQuestionInvalid": "Rhowch gyfeiriad e-bost dilys",
  "phoneQuestionInvalid": "Rhowch rif ffôn dilys",
  "imageQuestionInvalid": "Uwchlwythwch unrhyw ddelweddau sy’n ofynnol",
  "radioQuestionInvalid": "Dewiswch opsiwn o’r rhestr",
  "checkboxQuestionInvalid": "Dewiswch un neu fwy o opsiynau o’r rhestr",
  "defaultQuestionInvalid": "Atebwch y cwestiwn hwn",

  "notFoundTitle": "Heb ei Ganfod",
  "pageNotFoundBody": "Mae’n ddrwg gennym, nid oes unrhyw gynnwys yn y lleoliad hwn.",

  "siteSuspended": "Safle wedi’i atal",
  "unexpectedInputTitle": "Mewnbwn annisgwyl",
  "unexpectedInputBody": "Nid oeddem yn gallu prosesu eich mewnbwn. Adroddwyd am y gwall felly rhowch gynnig arall arni eto’n fuan. Os oes angen cymorth brys arnoch, cysylltwch â’r gwasanaethau diogelwch neu’r gwasanaethau brys.",
  "internalServerErrorTitle": "Gwall Gweinydd Mewnol",
  "internalServerErrorBody": "Aeth rhywbeth o’i le. Adroddwyd am y gwall felly dychwelwch yn fuan. Os oes angen cymorth brys arnoch, cysylltwch â’r gwasanaethau diogelwch neu’r gwasanaethau brys.",

  "auth": {
    "loading": "Llwytho'r tudalen mewngofnodi...",
    "signedIn": "Rydych chi wedi mewngofnodi",
    "signIn": "Mewngofnodi",
    "noProvider": "Gwall: Methu dod o hyd i'r darparwr hunaniaeth y mae'r wefan hon ei angen i fewngofnodi",
    "holding": "Arhoswch i gael eich ailgyfeirio. Os na chewch eich ailgyfeirio, ceisiwch eto.",
    "noAuthTitle": "Gwall mewngofnodi",
    "noAuthBody": "Ni dderbyniwyd eich cyflwyniad oherwydd nad oeddech wedi mewngofnodi."
  }
}
